import { render, staticRenderFns } from "./RfsTable.vue?vue&type=template&id=8e9423e4"
import script from "./RfsTable.vue?vue&type=script&lang=ts"
export * from "./RfsTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports